import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import { DateColumn, NameColumn } from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

export default function Header() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <DateColumn>Start</DateColumn>
      <DateColumn>Finish</DateColumn>
    </HeaderContainer>
  );
}
